/* eslint-disable array-callback-return */
/* eslint-disable no-self-assign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import _ from "lodash";
import {
  Alert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Paper as MuiPaper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Download } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import { CSVLink } from "react-csv";
import moment from "moment";
import PhysicalStockFilter from "./PhysicalStockFilter";
// import InOutFilter from "./InOutFilter";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(
  id,
  plate_name,
  physical_quantity,
  digital_quantity,
  date,
  difference
) {
  return {
    id,
    plate_name,
    physical_quantity,
    digital_quantity,
    date,
    difference,
  };
}

const headCells = [
  { key: "plate_name", alignment: "left", label: "Plate Name" },
  { key: "physical_quantity", alignment: "left", label: "Physical Quantity" },
  { key: "digital_quantity", alignment: "left", label: "Digital Quantity" },
  { key: "date", alignment: "left", label: "Updated At" },
  { key: "difference", alignment: "left", label: "Difference" },
];

const EnhancedTableHead = (props) => {
  const [head, setHeads] = useState(headCells);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const { rows, apCompanies, selectedApCompany, setSelectedApCompany } = props;
  // for filters
  const {
    createdDateFrom,
    setCreatedDateFrom,
    createdDateTo,
    setCreatedDateTo,
    apUsers,
    onFilter,
    csvPermission,
  } = props;
  const navigate = useNavigate();
  rows.forEach((row, i) => {
    rows[i].date = new Date(row.date).toLocaleString("en-IN");
  });
  let timestamp = moment().format("DD-MM-YY HH:mm");
  const csvReport = {
    filename: `${
      apCompanies.filter((item) => item._id === selectedApCompany)[0].name
    }_Physical_stock_${timestamp}.csv`,
    headers: headCells,
    data: rows,
  };
  return (
    <Toolbar>
      <ToolbarTitle>
        <Typography variant="h6" id="tableTitle">
          Physical Stock
        </Typography>
      </ToolbarTitle>
      <Spacer />
      {apCompanies && (
        <FormControl fullWidth>
          <InputLabel id="label">Select Ap Company</InputLabel>
          <Select
            labelId="label"
            fullWidth
            id="label"
            label="Select Ap Company"
            size="small"
            onChange={(e) => setSelectedApCompany(e.target.value)}
            value={selectedApCompany}
          >
            <MenuItem disabled value={""}>
              Select Ap Company
            </MenuItem>
            {apCompanies.map((u) => {
              return (
                <MenuItem key={u._id} value={u._id}>
                  {u.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}

      {csvPermission && (
        <CSVLink
          style={{ color: "green", textDecoration: "none" }}
          {...csvReport}
        >
          <Button
            variant="outlined"
            sx={{ ml: 2, mr: 2 }}
            endIcon={<Download />}
          >
            CSV
          </Button>
        </CSVLink>
      )}

      <div>
        <PhysicalStockFilter
          onFilter={onFilter}
          apUsers={apUsers}
          createdDateFrom={createdDateFrom}
          setCreatedDateFrom={setCreatedDateFrom}
          createdDateTo={createdDateTo}
          setCreatedDateTo={setCreatedDateTo}
        />
      </div>

      <div>
        <Tooltip title="Add Physical Entry">
          <IconButton aria-label="Add Physical Entry" size="large">
            <AddIcon
              onClick={() =>
                navigate("/dashboard/inventory/physical-stock/update")
              }
            />
          </IconButton>
        </Tooltip>
      </div>
    </Toolbar>
  );
};

const getApCompanies = async (
  setLoader,
  setApCompanies,
  setSelectedApCompany
) => {
  const userData = JSON.parse(localStorage.getItem("AuthData"));
  const config = {
    headers: {
      Authorization: "Bearer " + userData.access_token,
    },
  };
  const { data } = await axios.get(
    `/api/v1/${userData?.type}/plate_inventory/inward_outward/ap_companies`,
    config
  );
  const companies = data.data;
  setApCompanies(companies);
  if (companies && companies.length > 0) {
    setSelectedApCompany(companies[0]._id);
  }
  setLoader(false);
};

const getApUsers = async (selectedCompany, setApUsers, setLoader) => {
  setLoader(true);
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));

    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    let url = `/api/v1/${authData?.type}/plate_inventory/inward_outward/ap_users?ap_company=${selectedCompany}`;

    const apUsers = await axios.get(url, config);
    if (apUsers.data.success) {
      let finalData = apUsers.data.data;
      // let notIncludedPresentUser = apUsers.data.data.data.filter(
      //   (d) => d._id !== userData.user_id
      // );

      if (authData.type === "super_admin") {
        let user = {
          name: "super_admin",
          _id: authData.user_id,
        };
        finalData.push(user);
      }

      let presentUserIndex = finalData.findIndex(
        (u) => u._id === authData.user_id
      );
      if (presentUserIndex >= 0) {
        finalData[presentUserIndex].name = "YOURSELF";
        finalData.forEach(function (item, i) {
          if (item._id === authData.user_id) {
            finalData.splice(i, 1);
            finalData.unshift(item);
          }
        });
      }
      setApUsers(finalData);
    }

    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function EnhancedTable({
  rows,
  apCompanies,
  selectedApCompany,
  setSelectedApCompany,
  editPermission,
  viewPermission,
  // for filters
  entryType,
  setEntryType,
  quantity,
  setQuantity,
  approved,
  setApproved,
  rejected,
  setRejected,
  createdBy,
  setCreatedBy,
  apUsers,
  onFilter,
  height,
  width,
  thickness,
  setHeight,
  setWidth,
  setThickness,

  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  csvPermission,
}) {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);

  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert mt={2} mb={4} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar
          rows={rows}
          apCompanies={apCompanies}
          selectedApCompany={selectedApCompany}
          setSelectedApCompany={setSelectedApCompany}
          numSelected={selected.length}
          height={height}
          width={width}
          thickness={thickness}
          setHeight={setHeight}
          setWidth={setWidth}
          setThickness={setThickness}
          // for fileters
          quantity={quantity}
          setQuantity={setQuantity}
          entryType={entryType}
          setEntryType={setEntryType}
          approved={approved}
          setApproved={setApproved}
          rejected={rejected}
          setRejected={setRejected}
          createdBy={createdBy}
          setCreatedBy={setCreatedBy}
          apUsers={apUsers}
          onFilter={onFilter}
          createdDateFrom={createdDateFrom}
          setCreatedDateFrom={setCreatedDateFrom}
          createdDateTo={createdDateTo}
          setCreatedDateTo={setCreatedDateTo}
          csvPermission={csvPermission}
        />
        {rows.length === 0 ? (
          <Box
            sx={{
              height: "calc(100vh - 266px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5">
              No Physical Stock Entry for{" "}
              {
                apCompanies.filter((item) => item._id === selectedApCompany)[0]
                  .name
              }{" "}
              💽
            </Typography>
          </Box>
        ) : (
          <>
            <StyledTableContainer>
              <Table size={"small"}>
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  viewPermission={viewPermission}
                  editPermission={editPermission}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={`${row.id}-${index}`}
                        selected={isItemSelected}
                      >
                        <TableCell align="left">{row.plate_name}</TableCell>
                        <TableCell align="left">
                          {row.physical_quantity}
                        </TableCell>
                        <TableCell align="left">
                          {row.digital_quantity}
                        </TableCell>

                        <TableCell align="left">
                          {new Date(row.date).toLocaleString("en-IN")}
                        </TableCell>
                        <TableCell align="left">{row.difference}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
            <TablePagination
              rowsPerPageOptions={[50, 100, 250]}
              component="div"
              count={total_results}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </Paper>
    </div>
  );
}

function PhysicalStock({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [editPermission, setEditPermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [quantity, setQuantity] = useState(searchParams.get("quantity"));
  const [createdBy, setCreatedBy] = useState(searchParams.get("created_by"));
  const [approved, setApproved] = useState(searchParams.get("approved"));
  const [rejected, setRejected] = useState(searchParams.get("rejected"));
  const [entryType, setEntryType] = useState(searchParams.get("entry_type"));
  const [height, setHeight] = useState(searchParams.get("height"));
  const [width, setWidth] = useState(searchParams.get("width"));
  const [thickness, setThickness] = useState(searchParams.get("thickness"));

  const [apUsers, setApUsers] = useState(null);

  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 50
  );

  const [createdDateFrom, setCreatedDateFrom] = useState(
    searchParams.get("created_from") || ""
  );
  const [createdDateTo, setCreatedDateTo] = useState(
    searchParams.get("created_to") || ""
  );
  const [total, setTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeParams(0, event.target.value);
  };

  const changeParams = (queryPage, queryLimit) => {
    let query = `?`;

    query += `page=${queryPage}&limit=${queryLimit}`;
    navigate("/dashboard/inventory/physical-stock" + query, {
      replace: true,
    });
  };

  const getPhysicalStock = async (params = {}) => {
    const authData = JSON.parse(localStorage.getItem("AuthData"));

    let queryPage = searchParams.get("page");
    let queryLimit = searchParams.get("limit");

    setLoader(true);
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + token.access_token,
        },
      };
      // let url = `/api/v1/${authData?.type}/plate_inventory`;
      let url = `/api/v1/${authData.type}/physical_stock?`;

      queryPage ? (queryPage = Number(queryPage) + 1) : (queryPage = page + 1);
      queryLimit ? (queryLimit = queryLimit) : (queryLimit = rowsPerPage);

      url += `page=${queryPage}&limit=${queryLimit}`;

      let rows = [];
      url += "&ap_company=" + selectedApCompany;
      if (createdDateFrom) url += `&created_from=${createdDateFrom}`;
      if (createdDateTo) url += `&created_to=${createdDateTo}`;
      const { data } = await axios.get(url, config);

      if (data.success) {
        const result = data.data.data;
        setTotal(data.data.metadata.total_results);
        result.map((data) => {
          rows.push(
            createData(
              data._id,
              `${data.plate_info.height}x${data.plate_info.width}x${data.plate_info.thickness}`,
              data.physical_quantity,
              data.digital_quantity,
              data.updatedAt,
              data.digital_quantity - data.physical_quantity
            )
          );
        });
      }
      setRows(rows);
      setLoader(false);
    } catch (e) {
      console.log(e);
    }
    setLoader(false);
  };

  const onFilter = () => {
    let url = "/dashboard/inventory/physical-stock?";

    if (createdDateFrom) url += `&created_from=${createdDateFrom}`;
    if (createdDateTo) url += `&created_to=${createdDateTo}`;

    navigate(url, {
      replace: true,
    });
    let params = {};

    setPage(0);
    setRowsPerPage(50);

    getPhysicalStock();
  };

  useEffect(() => {
    if (token?.type === "super_admin") {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("view_in_out") ||
      token?.type === "super_admin"
    ) {
      setViewPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      token?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
  }, []);
  const [rows, setRows] = useState([]);
  const [apCompanies, setApCompanies] = useState([]);
  const [selectedApCompany, setSelectedApCompany] = useState(null);
  const returnParam = (value) => {
    return searchParams.get(value);
  };
  useEffect(() => {
    if (selectedApCompany) {
      getApUsers(selectedApCompany, setApUsers, setLoader);
      getPhysicalStock();
    }
  }, [selectedApCompany, page, rowsPerPage]);

  useEffect(async () => {
    // getPlates(token, setLoader, setRows);
    getApCompanies(setLoader, setApCompanies, setSelectedApCompany);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              Physical Stock
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>

              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>

              <Typography>Physical Stock</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              rows={rows}
              apCompanies={apCompanies}
              selectedApCompany={selectedApCompany}
              setSelectedApCompany={setSelectedApCompany}
              setRows={setRows}
              viewPermission={viewPermission}
              editPermission={editPermission}
              height={height}
              width={width}
              thickness={thickness}
              setHeight={setHeight}
              setWidth={setWidth}
              setThickness={setThickness}
              // for filters
              quantity={quantity}
              setQuantity={setQuantity}
              entryType={entryType}
              setEntryType={setEntryType}
              approved={approved}
              setApproved={setApproved}
              rejected={rejected}
              setRejected={setRejected}
              createdBy={createdBy}
              setCreatedBy={setCreatedBy}
              apUsers={apUsers}
              onFilter={onFilter}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              createdDateFrom={createdDateFrom}
              setCreatedDateFrom={setCreatedDateFrom}
              createdDateTo={createdDateTo}
              setCreatedDateTo={setCreatedDateTo}
              csvPermission={csvPermission}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(PhysicalStock);
